<template>
	<div>
		<v-content>
			<v-container fluid>
              <center v-if="loaded == false"><img class="imgLoader" src="../../shared/assets/images/3dloader.gif" /></center>
              <v-flex xs3 v-if="loaded == true">
                <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
              </v-flex>
				<v-data-table v-if="loaded == true" :headers="headers" :search="search" :items="discountList" class="elevation-1" style="font-size: 10px;"  :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">
						<td width="10%" class="text-xs-right">{{ props.item.created }}</td>
						<td width="30%" class="text-xs-right">{{ props.item.request_status_display }}</td>
						<td width="12%" class="text-xs-right">{{ props.item.draft_reference }}</td>
						<td width="12%" class="text-xs-right">{{ props.item.quote_no }}</td>
						<td width="12%" class="text-xs-right">{{ props.item.metadata.customer_name }}</td>
						<td width="12%" class="text-xs-right">{{ props.item.metadata.requestor_user_name }}</td>
						<td width="12%" class="text-xs-right">{{ props.item.metadata.init_user_name }}</td>
					</template>
				</v-data-table>
			</v-container>
		</v-content>
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';

  export default {
	name: 'QuoteList',
    data () {
		return {
			search: '',			
            headers: [
                { text: 'Request Timestamp', value: 'created', width: '10%' },
                { text: 'Request Status', value: 'status', width: '30%' },
                { text: 'Draft Reference', value: 'draftReference', width: '12%' },
                { text: 'Quote Reference', value: 'quoteReference', width: '12%' },
                { text: 'Customer', value: 'customer', width: '12%' },
                { text: 'Requestor', value: 'requestor', width: '12%' },
                { text: 'Authoriser', value: 'authorizer', width: '12%' }
            ],
            loaded: false
		}
	},
	methods: {
		
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'discountList',
			'objDiscountReportFilters'
		])
	},
	beforeMount() {		
		if( this.objDiscountReportFilters.authorizer == 'NaN' ) {
			this.objDiscountReportFilters.authorizer = '';
		}
		if( this.objDiscountReportFilters.requestor == 'NaN' ) {
			this.objDiscountReportFilters.requestor = '';
		}		
        this.$store.dispatch({
            type: 'fncPopulateDiscountList',
            objFilters: this.objDiscountReportFilters
        })
    },
    watch: {
      discountList() {
        this.loaded = true;
      }
    }
}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>